import { render, staticRenderFns } from "./UpdateGroupClassByMasterDialog.vue?vue&type=template&id=6d0a5800"
import script from "./UpdateGroupClassByMasterDialog.vue?vue&type=script&lang=js"
export * from "./UpdateGroupClassByMasterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports